export function findById<T extends { id: string | number }>(
  list: T[],
  id: string | number
): T | undefined {
  return list.find(({ id: itemId }) => itemId === id);
}
